"use strict";var e=require("@apollo/client"),t=e.gql`
  query GetPCStoresByClient($clientId: String!, $filter: LocationFilter) {
    getPCStoresByClient(clientId: $clientId, filter: $filter) {
      phone
      id
      name
      code
      state
      cities {
        name
      }
      address
      country
      operationModel
      serviceFee {
        PICK_AND_COLLECT
        DELIVERY
      }
    }
  }
`,r=e.gql`
  query GetPCStoresByClient(
    $clientId: String!
    $filter: LocationFilter
    $storeReferences: [String!]
  ) {
    getPCStoresByClient(
      clientId: $clientId
      filter: $filter
      storeReferences: $storeReferences
    ) {
      phone
      id
      name
      code
      state
      cities {
        name
      }
      address
      country
      dynamicParams
      operationModel
      serviceFee {
        PICK_AND_COLLECT
        DELIVERY
      }
    }
  }
`;exports.a=r,exports.g=t;